import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { ensureDate } from '@zapier/date';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks/useCurrentAccountId';

import { billingPeriod as BillingPeriodQuery } from './types/billingPeriod';

export const billingPeriodQuery = gql`
  query billingPeriod($accountId: Int!) {
    account(id: $accountId) {
      id
      periodEndDate
      periodStartDate
    }
  }
`;

export const useBillingPeriod = () => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<BillingPeriodQuery>(
    billingPeriodQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  const periodEndDate = data?.account?.periodEndDate;
  const periodStartDate = data?.account?.periodStartDate;

  return {
    error: error
      ? 'There was an issue loading billing period data.'
      : undefined,
    isLoading: loading,
    periodEndDate: periodEndDate ? ensureDate(periodEndDate) : undefined,
    periodStartDate: periodStartDate ? ensureDate(periodStartDate) : undefined,
  };
};
